export default __webpack_public_path__ + "static/media/toShow-10-min.8f60cc7a.jpg";